import {
  DefaultApi,
  GetChecklistDto,
  GetErrorListDto,
  GetStepDefinitionDto,
  ToggleManualStepCompletionDto,
} from '../autogenerated/pokApiClient';

export interface StepDefinitionContextInterface {
  getAllActive: () => Promise<GetStepDefinitionDto[]>;
  getChecklist: (
    projectId: string,
    stageDefinitionId: string,
    profileId: string,
    month: Date,
  ) => Promise<GetChecklistDto>;
  toggleManualStepCompletion: (
    dto: ToggleManualStepCompletionDto,
  ) => Promise<void>;
  getErrorList: (
    projectId: string,
    stageDefinitionId: string,
    profileId?: string,
    month?: Date,
  ) => Promise<GetErrorListDto>;
  getNoOrderRequired: (estimateItemId: string) => Promise<boolean>;
  setNoOrderRequired: (
    estimateItemId: string,
    checked: boolean,
  ) => Promise<void>;
}

export const StepDefinitionContext = (api: DefaultApi) => {
  return {
    getAllActive: () => api.stepDefinitionControllerGetAllActiveSteps(),
    getChecklist: (
      projectId: string,
      stageDefinitionId: string,
      profileId: string,
      month: Date,
    ) =>
      api.stepDefinitionControllerGetChecklist(
        projectId,
        stageDefinitionId,
        profileId,
        month,
      ),
    toggleManualStepCompletion: (dto: ToggleManualStepCompletionDto) =>
      api.stepDefinitionControllerToggleManualStepCompletion(dto),
    getErrorList: (
      projectId: string,
      stageDefinitionId: string,
      profileId?: string,
      month?: Date,
    ) =>
      api.stepDefinitionControllerGetErrorList(
        projectId,
        stageDefinitionId,
        profileId,
        month,
      ),
    getNoOrderRequired: (estimateItemId: string) =>
      api.stepDefinitionControllerGetNoContractRequired(estimateItemId),
    setNoOrderRequired: (estimateItemId: string, checked: boolean) =>
      api.stepDefinitionControllerSetNoContractRequired({
        estimateItemId,
        checked,
      }),
  };
};
